var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRatingIco(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 81,
    viewBox: "0 0 82 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.2602 6.1087V1H18.3906V6.1087",
    stroke: "#EEEBE7",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2174 79.3333H1V4.40576H18.3913V11.2174H39.2609V4.40576H60.1304V28.2463",
    stroke: "#EEEBE7",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1738 40.1666H23.6086L30.5651 33.3551H39.2608L46.2173 26.5435H51.4347",
    stroke: "#EEEBE7",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1738 46.9781H32.3043L37.5217 43.5723H51.4347",
    fill: "#EEEBE7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1738 46.9781H32.3043L37.5217 43.5723H51.4347",
    stroke: "#EEEBE7",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0736 72.5216H7.95703V11.2173H13.1744",
    stroke: "#EEEBE7",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1748 33.355V11.2173H39.2617",
    stroke: "#EEEBE7",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6086 65.71H13.1738",
    stroke: "#EEEBE7",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9565 18.0288H41",
    stroke: "#EEEBE7",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6086 58.8984H13.1738",
    stroke: "#EEEBE7",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6514 45.2753C56.6514 49.0373 59.766 52.0869 63.6079 52.0869C67.4499 52.0869 70.5645 49.0373 70.5645 45.2753V41.8695C70.5645 38.1076 67.4499 35.0579 63.6079 35.0579C59.766 35.0579 56.6514 38.1076 56.6514 41.8695V45.2753Z",
    stroke: "#EEEBE7",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0859 52.0869V55.4927L76.7828 58.8321C78.0341 59.3572 79.1006 60.2303 79.85 61.3432C80.5995 62.4561 80.999 63.7599 80.999 65.0929V79.3333",
    stroke: "#EEEBE7",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1298 52.0869V55.4927L50.433 58.8321C49.1817 59.3572 48.1152 60.2303 47.3657 61.3432C46.6163 62.4561 46.2168 63.7599 46.2168 65.0929V79.3333",
    stroke: "#EEEBE7",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M74.043 69.1162V79.3336",
    stroke: "#EEEBE7",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1738 69.1162V79.3336",
    stroke: "#EEEBE7",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatingIco);
export default __webpack_public_path__ + "static/media/rating-ico.25a9c02ceff398749dfef83ce97a218f.svg";
export { ForwardRef as ReactComponent };